/**
 * IMTask auth SHIM per ARCHI-HUB.
 *
 * IMTask internamente si aspetta un ``useAuth()`` che restituisca ``{ user, logout }``.
 * Qui non montiamo alcun AuthProvider proprio: leggiamo direttamente il contesto di
 * ARCHI-HUB (`../../../context/AuthContext`) e adattiamo la shape.
 *
 * `user` ARCHI-HUB → `{ id, email, name, role, ... }` — già compatibile.
 * `logout` chiama quello di ARCHI-HUB (rimuove ah_token + redirect al login).
 *
 * Effetto collaterale: al mount imposta ``window.__ARCHIHUB_USER__`` e
 * ``window.__CURRENT_USER_ID__`` (usati dall'api.js originale per session_id AI).
 */
import { useEffect } from "react";
import { useAuth as useArchiHubAuth } from "../../../context/AuthContext";

export function useAuth() {
  const { user, logout } = useArchiHubAuth();
  useEffect(() => {
    if (user && user.id) {
      window.__ARCHIHUB_USER__ = user;
      window.__CURRENT_USER_ID__ = user.id;
    }
  }, [user]);
  return { user: user || null, checking: false, logout };
}

// Non usato in IMTask integrato, ma esportato per compatibilità di import.
export function AuthProvider({ children }) {
  return children;
}
